// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "mg-mczx/static/js/" + chunkId + "." + {"216":"9b23c06b","407":"bf5537ca","551":"8289bd20","750":"a81381c1"}[chunkId] + ".js";
};